import React from "react";

import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import AppContextSchedulingConfirmStepWrapper from "./AppContextSchedulingConfirmStepWrapper";
import AppContextSchedulingLoader from "./AppContextSchedulingLoader";

const HybridCalendarSchedulingStep: React.FC<IStepWrapperButtonProps> = props => (
  <AppContextSchedulingLoader>
    <AppContextSchedulingConfirmStepWrapper {...props} />
  </AppContextSchedulingLoader>
);

export default HybridCalendarSchedulingStep;
